import React from "react";
import Typography from "@material-ui/core/Typography";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import { Button } from "@material-ui/core";
import CheckboxItem, { useStylesAcc } from "../CheckBoxComponent";
import { useTranslation } from "react-i18next";
const formData = [
    {
        name: "SalePointOnly",
        label: "enable-pos-screen-for-user",
        visible: true,
    },
    {
        name: "used_Nsale_screen",
        label: "use-sales-screen",
        visible: true,
    },
    {
        name: "used_Rsale_screen",
        label: "use-return-screen",
        visible: true,
    },
    {
        name: "used_switch_screen",
        label: "use-replace-screen",
        visible: false,
    },
    {
        name: "used_Items_screen",
        label: "use-item-entry-screen",
        visible: true,
    },
    {
        name: "used_Group_screen",
        label: "use-groups-screen",
        visible: true,
    },
    {
        name: "used_Bcode_screen",
        label: "use-barcode-print",
        visible: false,
    },
    {
        name: "used_Jarde_screen",
        label: "use-item-inventory-screen",
        visible: true,
    },
    {
        name: "used_jrans_screen",
        label: "use-detailed-item-movement-inventory",
        visible: true,
    },
    {
        name: "used_Dialy_screen",
        label: "use-daily-movement-report",
        visible: true,
    },
    {
        // this field for users table
        name: "used_Point_screen",
        label: "reset-pos-statistics-display",
        visible: false,
    },
    {
        name: "used_Treas_screen",
        label: "use-cashbox-movement-report",
        visible: true,
    },
    {
        name: "used_Accnt_screen",
        label: "use-account-statement-screen",
        visible: true,
    },
    {
        name: "used_SSarf_screen",
        label: "use-payment-voucher-screen",
        visible: true,
    },
    {
        name: "used_itmove_screen",
        label: "use-item-movement-report-screen",
        visible: true,
    },
    {
        name: "used_Sqabd_screen",
        label: "use-receipt-voucher-screen",
        visible: true,
    },
    {
        name: "used_purch_screen",
        label: "use-purchases-screen",
        visible: true,
    },
    {
        name: "used_Rpurch_screen",
        label: "use-purchase-return-screen",
        visible: true,
    },
    {
        name: "notShowSales",
        label: "hide-sales-show-invoice-count",
        visible: true,
    },
    {
        name: "disable_customer",
        label: "disable-customer-cash-only",
        visible: true,
    },
    {
        name: "pos_dashboard_zero",
        label: "reset-pos-statistics-display",
        visible: true,
    },
    {
        name: "pos_dashboard_zero",
        label: "reset-pos-statistics-display",
        visible: true,
    },
    {
        name: "used_twreed_makhzni_screen",
        label: "use-stock-supply-screen",
        visible: true,
    },
    {
        name: "used_sarfe_mkhzni_screen",
        label: "use-stock-issue-screen",
        visible: true,
    },
    {
        name: "used_estlam_mkhzni_screen",
        label:"use-stock-receipt-screen",
        visible: true,
    },
    {
        name: "used_tasweay_mkhzni_screen",
        label:"use-stock-settlement-screen",
        visible: true,
    },
    { name: "", label: "allow-discount", visible: false },
];

export default function POSPermissions(props) {
    const { onChange, object, update, submitting, userPoint, gData } = props;
    const { t } = useTranslation(["forms"]);

    const classes = useStylesAcc();

    return (
        <div className={classes.root}>
            <Accordion expanded={true}>
                <AccordionDetails>
                <Grid item container spacing={1}>
                            {formData
                                ?.filter((d) => d.visible && gData.user.User_type === 1? d.name!=="SalePointOnly":d.name=d.name)
                                ?.map((item) => {
                                    return (
                                        <Grid xs={6}>
                                            <CheckboxItem
                                                value={object[item.name] ?? null}
                                                name={item.name}
                                                label={t(item.label)}
                                                onChange={onChange}
                                            />
                                        </Grid>
                                    );
                                })}
                        </Grid>
                </AccordionDetails>

                <Divider className={classes.divider} />

                {/* <AccordionDetails className={classes.subTitle}>
                    {" "}
                    <Typography>
                        {" "}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="large"
                            disabled={props.submitting}
                            onClick={update}
                        >
                            {t("save-changes")}
                        </Button>
                    </Typography>{" "}
                </AccordionDetails> */}
            </Accordion>
            <Swipeable />
        </div>
    );
}
